import {
  TRANSPORT_METHOD_TYPE,
  TransportMethodType,
} from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { formatSimpleAddressOneLine } from '@savgroup-front-common/core/formatters/address';
import { HandlingSpot, MessageType } from '@savgroup-front-common/types';

import messages from '../messages';

interface AdaptDeliveryCardAddressArgs {
  delivery: HandlingSpot;
  fallbackAddressStreet: string;
  getCountryTranslation: (country: string) => string;
}

interface DeliveryCardAddress {
  label?: MessageType;
  addressName?: string;
  addressStreet: string;
}

const HOME_DELIVERY_METHOD_TYPES: TransportMethodType[] = [
  TRANSPORT_METHOD_TYPE.HomeDelivery,
  TRANSPORT_METHOD_TYPE.BulkyHomeDelivery,
];

export function adaptDeliveryCardAddress({
  delivery,
  fallbackAddressStreet,
  getCountryTranslation,
}: AdaptDeliveryCardAddressArgs): DeliveryCardAddress {
  const transportMethodType = delivery.transportPlanMethodType;
  const deliveryAddress = delivery.address || delivery.pickupPointAddress;
  const deliveryAddressStreet = formatSimpleAddressOneLine(
    deliveryAddress,
    getCountryTranslation,
  );

  if (transportMethodType === TRANSPORT_METHOD_TYPE.PickUpRelayPointDelivery) {
    const pickupAddress = delivery.pickupPointAddress?.address
      ? delivery.pickupPointAddress
      : delivery.address;

    return {
      label: messages.pickupPoint,
      addressName:
        delivery.pickupPointFullName ||
        `${pickupAddress?.firstname || ''} ${pickupAddress?.lastname || ''}`,
      addressStreet: formatSimpleAddressOneLine(
        pickupAddress,
        getCountryTranslation,
      ),
    };
  }

  if (
    transportMethodType &&
    HOME_DELIVERY_METHOD_TYPES.includes(transportMethodType)
  ) {
    return {
      addressName: `${delivery.address?.firstname || ''} ${delivery.address?.lastname || ''}`,
      addressStreet: formatSimpleAddressOneLine(
        delivery.address,
        getCountryTranslation,
      ),
    };
  }

  return {
    addressName:
      delivery.pickupPointFullName ||
      `${deliveryAddress?.firstname || ''} ${deliveryAddress?.lastname || ''}`,
    addressStreet: deliveryAddressStreet || fallbackAddressStreet,
  };
}
